import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "@/store/security";

const HS256AuthEndpoints = ["createOrganisationApiV1OrganisationsPost"];

export const emptyApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_BASE_URL ?? "/",
    fetchFn: async (input, init) => {
      return await fetch(input, init);
    },
    prepareHeaders: async (headers, { endpoint }) => {
      let access_token = undefined;
      if (HS256AuthEndpoints.includes(endpoint)) {
        access_token = new URL(window.location.href).searchParams.get("session_token");
      } else {
        access_token = await sec.getAccessTokenSilently()();
      }
      if (access_token) {
        headers.set("Authorization", `Bearer ${access_token}`);
      }

      return headers;
    }
  }),
  endpoints: () => ({})
});
